var installedModules = {};
var moduleToHandlerMapping = {
	84588: {
		getter: () => (Promise.all([__webpack_require__.e(671), __webpack_require__.e(439)]).then(() => (() => (__webpack_require__(93439))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~7.8.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "rxjs/operators",
	},
	94172: {
		getter: () => (Promise.all([__webpack_require__.e(671), __webpack_require__.e(329)]).then(() => (() => (__webpack_require__(6329))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~7.8.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "rxjs",
	},
	82344: {
		getter: ()=>()=>{throw new Error("Can not get '@angular/core'")},
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core",
	},
	25005: {
		getter: ()=>()=>{throw new Error("Can not get '@angular/common/http'")},
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/common/http",
	},
	82006: {
		getter: ()=>()=>{throw new Error("Can not get '@angular/core/rxjs-interop'")},
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/core/rxjs-interop",
	},
	20136: {
		getter: ()=>()=>{throw new Error("Can not get '@angular/forms'")},
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/forms",
	},
	90114: {
		getter: ()=>()=>{throw new Error("Can not get '@angular/common'")},
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/common",
	},
	40626: {
		getter: () => (Promise.all([__webpack_require__.e(981), __webpack_require__.e(323)]).then(() => (() => (__webpack_require__(16323))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~7.8.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "rxjs",
	},
	65314: {
		getter: () => (Promise.all([__webpack_require__.e(981), __webpack_require__.e(809)]).then(() => (() => (__webpack_require__(68809))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~7.8.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "rxjs/operators",
	},
	73685: {
		getter: ()=>()=>{throw new Error("Can not get '@angular/platform-browser'")},
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/platform-browser",
	},
	40610: {
		getter: ()=>()=>{throw new Error("Can not get '@angular/router'")},
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/router",
	},
	17367: {
		getter: () => (__webpack_require__.e(331).then(() => (() => (__webpack_require__(10331))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.3.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "tslib",
	},
	5896: {
		getter: () => (__webpack_require__.e(0).then(() => (() => (__webpack_require__(36000))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.3.0",
			  "strictVersion": true,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "tslib",
	},
	42520: {
		getter: ()=>()=>{throw new Error("Can not get '@angular/platform-browser/animations/async'")},
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "@angular/platform-browser/animations/async",
	}
};
var initialConsumes = [84588,94172,82344,25005,82006,20136,90114,40626,65314,73685,40610,17367];
__webpack_require__.federation.installInitialConsumes = () => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}))
var chunkMapping = {
	"482": [
		42520
	],
	"792": [
		84588,
		94172,
		82344,
		25005,
		82006,
		20136,
		90114,
		40626,
		65314,
		73685,
		40610,
		17367
	],
	"981": [
		5896
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}